module.exports = __webpack_public_path__ + "img/offer-not-available.253a1122.png";